export const PREVIEW_APPLICATION_ID = 'app.tago.preview'

type RuntimePlatform = string

/**
 * Decides Preview identity from an immutable native identifier whenever one
 * exists. A Metro dev-server manifest is intentionally not trusted on native:
 * it can be resolved from a developer's current shell and must never make the
 * production package behave like the fixture app.
 */
export function isIsolatedPreviewRuntime(input: {
  applicationId: string | null | undefined
  platform: RuntimePlatform
  manifestPreviewFlag: boolean
}): boolean {
  if (input.applicationId) return input.applicationId === PREVIEW_APPLICATION_ID

  // Web has no native application identifier. Its published manifest is the
  // build identity, while native apps deliberately fail closed above.
  return input.platform === 'web' && input.manifestPreviewFlag
}
